import Vue from 'vue'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import './styles/index.css'
import App from './App.vue'
import VueRouter from 'vue-router'
import Login from './components/Login.vue'
import Dashboard from './components/company/Dashboard.vue'
import Main from './components/Main.vue'
import Companies from './components/company/Companies.vue'
import AuthNameManager from './components/device/AuthNameManager.vue'
import Devices from './components/device/Devices.vue'
import VersionManager from './components/version/VersionManager'
import VCodeManager from './components/vcode/VCodeManager'
import ExcelGen from './components/device/ExcelGen'
import CompanySettings from './components/company/CompanySettings'
import WarningsDevices from './components/device/WarningsDevices'
import QQMusic from "@/components/settings/QQMusic";
import {DatePicker} from 'element-ui';
import * as echarts from 'echarts'
import 'echarts/theme/dark.js';
import axios from 'axios'
import ResourceManager from "@/components/resource/ResourceManager";
import StaticStatisticsSetting from "@/components/visualization/StaticStatisticsSetting";
import UserManager from "@/components/user/UserManager";

Vue.config.productionTip = false

Vue.prototype.$echarts = echarts

Vue.prototype.$http = axios
//别忘了download.html里面的地址
//禁用同源性检测"C:\Program Files (x86)\Microsoft\Edge\Application\msedge.exe"  --args --user-data-dir="D:\tmp"  --disable-web-security
// axios.defaults.baseURL = 'http://129.211.188.236:8990/xiaoyun'
axios.defaults.baseURL = 'https://www.szyundong.top/xiaoyun'
// axios.defaults.baseURL = 'http://127.0.0.1:8090'
axios.interceptors.request.use(config => {
    window.console.log('request ' + config.url);
    if (config.url.startsWith('/api/user/verification/') || config.url === '/api/user/login/') {
        window.console.log('ignore token');
    } else {
        let userToken = localStorage.getItem('user_data');
        if (userToken) {
            window.console.log('request token ' + userToken);
            config.headers['Authorization'] = userToken;
        }
    }
    return config;
});

axios.interceptors.response.use(response => {
    window.console.log('response is ' + JSON.stringify(response.data));
    return response;
});

Vue.use(VueMaterial)

Vue.use(VueRouter)

Vue.use(DatePicker);

const routes = [
    {path: '/login', component: Login},
    {
        path: '/dashboard', component: Dashboard,
        children: [
            {path: 'company-list', component: Companies},
            {path: 'auth-manager/:company_id', component: AuthNameManager},
            {path: 'device-list/:company_id', component: Devices},
            {path: 'company-settings/:company_id', component: CompanySettings},
            {path: 'version', component: VersionManager},
            {path: 'user', component: UserManager},
            {path: 'vcode', component: VCodeManager},
            {path: 'excel', component: ExcelGen},
            {path: 'warnings', component: WarningsDevices},
            {path: 'qq-music', component: QQMusic},
            {path: 'resource', component: ResourceManager},
            {path: 'static-settings', component: StaticStatisticsSetting},
            {path: '', redirect: 'company-list'},
        ]
    },
    {path: '/main', component: Main},
    {path: '/', redirect: 'dashboard'}
]
const router = new VueRouter({
    routes // (缩写) 相当于 routes: routes
})

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')
